import { Fragment, useContext, useEffect, useState } from "react";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import {
  createFilterReadyFlowsQueryString,
  createQueryString,
  sendApiRequest,
} from "../../services/Base/base-service";

import UserContext from "../../store/user-context";
import FlowsAITable from "../../components/Tables/FlowsAITable";
import Filters from "../../components/Header/Filters";
import { Alert, Section, Spinner } from "design-react-kit";
import Footer from "../../components/Footer";
import ConfirmDeleteModal from "../../components/Modals/ConfirmDeleteModal";
import { notifyUser } from "../../services/helpers";

const FlowsAI = () => {
  const [flows, setFlows] = useState(null);
  const [selectedFlow, setSelectedFlow] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [filterCodes, setFilterCodes] = useState(null);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    if (userContext.selectedClientFiscalCode !== null) {
      getReadyFlows(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext.selectedClientFiscalCode]);

  const getReadyFlows = (filterCodes) => {
    setIsLoading(true);
    setError(null);
    setTimeout(() => {
      sendApiRequest(
        "Flow/GetReadyFlows",
        "GET",
        true,
        {
          fiscalCode: userContext.selectedClientFiscalCode,
          codes: filterCodes,
        },
        signIn,
        signOut,
        navigate,
        createFilterReadyFlowsQueryString,
        userContext,
      ).then((response) => {
        if (response !== undefined) {
          if (response.errors !== null) {
            setError(response.errors);
            setIsLoading(false);
          } else {
            setError(null);
            setFlows(response.data.readyFlows);
            setIsLoading(false);
          }
        }
      });
    }, 500);
  };

  const openModalHandler = (flow) => {
    setModalOpen(true);
    setSelectedFlow(flow);
  };

  const closeModalHandler = () => {
    setModalOpen(false);
  };

  const authorizeForSendingHandler = (flowId) => {
    sendApiRequest(
      `Flow/AuthorizeFlowForSending/${flowId}`,
      "POST",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext,
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
        } else {
          setTimeout(() => {
            setError(null);
            sendApiRequest(
              "Flow/GetReadyFlows",
              "GET",
              true,
              {
                fiscalCode: userContext.selectedClientFiscalCode,
                flowId: null,
              },
              signIn,
              signOut,
              navigate,
              createQueryString,
              userContext,
            ).then((response) => {
              if (response !== undefined) {
                if (response.errors !== null) {
                  setError(response.errors);
                  setIsLoading(false);
                  setModalOpen(false);
                } else {
                  setError(null);
                  setFlows(response.data.readyFlows);
                  setIsLoading(false);
                  setModalOpen(false);
                  notifyUser(
                    "La trasmissione del flusso notifiche è stata autorizzata e per questo motivo non sarà più visibile in questo elenco; lo stato di avanzamento della sua effettiva trasmissione potrà essere a breve visionato nella sessione di monitoraggio flussi.",
                    "success",
                    "it-check",
                    10000,
                  );
                }
              }
            });
          }, 500);
        }
      }
    });
  };

  return (
    <Fragment>
      <Filters
        page="readyFlows"
        filter={getReadyFlows}
        setFilterCodesHandler={setFilterCodes}
      />
      <Section>
        {error !== null && error.length !== undefined && (
          <Alert color="danger" className="mx-auto">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        {isLoading && (
          <p
            style={{
              height: "50px",
              position: "relative",
              marginBottom: "3rem",
            }}
          >
            <Spinner double active />
          </p>
        )}
        {error === null && !isLoading && (
          <FlowsAITable
            items={flows}
            columns={[
              {
                name: "Data di predisposizione",
                type: "date",
                sortable: true,
                value: "predispositionDate",
              },
              {
                name: "Nome del flusso",
                type: "string",
                sortable: true,
                value: "flowName",
              },
              {
                name: "Tipologia",
                type: "string",
                sortable: true,
                value: "clientCodeName",
              },
              {
                name: "Codice Tipologia",
                type: "string",
                sortable: false,
                value: "clientCode",
              },
              {
                name: "Formato",
                type: "string",
                sortable: false,
                value: "format",
              },
              {
                name: "Numero di notifiche",
                type: "date",
                sortable: false,
                value: "notificationNumber",
              },
              {
                name: "",
                type: null,
                sortable: false,
                value: "",
              },
            ]}
            openModalHandler={openModalHandler}
            getReadyFlows={getReadyFlows}
            filterCodes={filterCodes}
          />
        )}
      </Section>
      <Footer />
      <ConfirmDeleteModal
        confirmModalOpen={modalOpen}
        confirmModalCloseHandler={closeModalHandler}
        flowId={selectedFlow?.id}
        target={selectedFlow?.flowName}
        error={error}
        isLoading={isLoading}
        text={"Sei sicuro di voler inviare il flusso?"}
        actionHandler={authorizeForSendingHandler}
        confirmButtonText="Sì, trasmetti"
      />
    </Fragment>
  );
};

export default FlowsAI;
